import { jsx as _jsx } from "react/jsx-runtime";
import { LogoAndHeading } from './logo-and-heading.component';
import { PerceivedHearingStatusContent } from './perceived-hearing-content.component';
import { StepLayout } from './step-layout.component';
import { pageImages } from '@/pages/images';
import { NavigationButton, NavigationButtonsContainer, } from '@/components/navigation-button.component';
export function PerceivedHearingStatusSelect() {
    return (_jsx(StepLayout, { image: pageImages.manListeningIntently, progress: {
            phase: 0,
            step: 3,
        }, heading: _jsx(LogoAndHeading, { headingText: 'Do you think you have a hearing problem?', className: "text-lg md:text-2xl", image: {
                height: 110,
                width: 118,
            } }), content: _jsx(PerceivedHearingStatusContent, {}), nav: _jsx(NavigationButtonsContainer, { children: _jsx(NavigationButton, { type: "back", variant: "outlined", label: "Previous" }) }) }));
}
